module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"mantra":"How can we |help you?","searchPlaceholder":"Describe your issue","search":"Search"},"ar":{"mantra":"كيف يمكننا |مساعدتك؟","searchPlaceholder":"وصف المشكلة","search":"بحث"}}')
  delete Component.options._Ctor
}
